import { LogLevel, type Configuration } from '@azure/msal-browser';

const clientId = import.meta.env.VITE_SIFT_AZURE_CLIENT_ID ?? '';
const tenantId = import.meta.env.VITE_SIFT_AZURE_TENANT_ID ?? '';
const apiScope = import.meta.env.VITE_SIFT_AZURE_API_SCOPE ?? '';

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: tenantId ? `https://login.microsoftonline.com/${tenantId}` : 'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    // localStorage, not sessionStorage: sessionStorage is per-tab and dies with the
    // tab, so opening SIFT in a new tab or reopening the browser forced a fresh
    // sign-in. §5.2 fixed mid-session 401s but never touched persistence.
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback(level, message, containsPii) {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error('[MSAL]', message);
        if (level === LogLevel.Warning) console.warn('[MSAL]', message);
      },
    },
    allowRedirectInIframe: false,
  },
};

export const loginRequest = {
  // Default to OIDC scopes so local sign-in works even before an API scope is exposed.
  // If your Entra app exposes a custom API scope, set VITE_SIFT_AZURE_API_SCOPE.
  scopes: apiScope ? [apiScope] : ['openid', 'profile', 'email'],
};

export const entraEnabled = Boolean(clientId && tenantId);

// Password sign-in is local-only: deployed builds are never DEV, and the backend refuses it there too.
export const legacyAuthEnabled = import.meta.env.DEV;

